.ripple {
  position: relative;
  overflow: hidden;
}

/**
 * The "shine" element
 */

.ripple:after {
  animation: ripple 6s cubic-bezier(0, 0, 0.2, 1) infinite;
  animation-fill-mode: forwards;
  content: '';
  position: absolute;
  top: -110%;
  left: -210%;
  width: 200%;
  height: 200%;
  opacity: 0;

  background: rgba(255, 255, 255, 0.13);
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.13) 50%,
    rgba(255, 255, 255, 1) 75%,
    rgba(255, 255, 255, 0) 100%
  );
}

/* Hover state - trigger effect */

/* Active state */

.ripple:active:after {
  opacity: 0;
}

@keyframes ripple {
  10% {
    opacity: 1;
    top: -30%;
    left: -30%;
    transition-property: left, top, opacity;
    transition-duration: 0.5s, 0.5s, 0.15s;
    transition-timing-function: ease;
  }
  100% {
    opacity: 0;
    top: -30%;
    left: -30%;
    transition-property: left, top, opacity;
  }
}
